import { scopedApi } from '@/session/scopedClients';
import { GLOBAL_SCOPE } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  id: string | number;
};

type Response = any;

const validate = (id: string | number) => {
  if (id === null || id === undefined || id === '') {
    throw new Error('`id` is required');
  }
};

export const deleteDashboardAlert = async ({ id }: RequestParams, options: WriteRequestOptions): Promise<EndpointResponse<Response>> => {
  try {
    validate(id);

    const result = await scopedApi(GLOBAL_SCOPE).delete<EndpointResponse<Response>>(`dashboard_alert/${id}`, options);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
